import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import ClientForm from "./ClientForm";
import InputCombo from "../../helpers/InputCombo";

import back from "../../back.png";
import ServiceRedirectForm from "./ServiceRedirectForm";


function ServiceRedirect(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [umowa, setContract] = useState(props.umowa);
    const [usluga, setServices] = useState(props.usluga);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        uslugi_id: props.id,   
        nazwa:  '',           
        telefon:  '',           
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [view, setView] = useState ( "list");

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);






        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {
 
        

            setFilterParam({
                uslugi_id: props.id,
                nazwa: '',                 
                telefon: '',                 
                        
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_home,redirect', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }






      const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');
            setView({...view, ["v"]:v, ["id"]:id });
    }

  


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }

    




       const keyListener = (e) => {
                       var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                                setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }
   }



   useEffect( ()=>{

            if(Config.env == "dev") console.log("ServieRedirect.js, listener on");
            window.onkeydown = keyListener; 

            return () => {   
                 if(Config.env == "dev") console.log("ServiceRedirect.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );





    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);    
    }



    if(tab == null)
    {
        setTab([]);
        getTab();     
        return <div>
            ...
        </div>
    }


    document.title = umowa.numer_umowy + ", " + usluga.nazwa_uslugi;




    
    if(view.v == "new")
    {
        return <ServiceRedirectForm  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess} uslugi_id={props.id} umowa={props.umowa} usluga={props.usluga}    id={view.id} />
    }


    if(view.v == "edit")
    {
        return <ServiceRedirectForm  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess} uslugi_id={props.id} umowa={props.umowa} usluga={props.usluga}    id={view.id} />
    }


    return  <div className="view_content">
       
                <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/> 
                
                <h3 className="dash_header"> {umowa.numer_umowy} / {usluga.nazwa_uslugi}  / Lista przekierować</h3>


                <div className="table_filter">

                        <div className="filter_controll">   
                                <label>Nazwa: </label>                             
                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                        </div> 

                         <div className="filter_controll">   
                                <label>Telefon: </label>                             
                                <InputText   userData={props.userData} value={filterParam.telefon}   valChange={valChangeListener} goNext={goNextNew} name="telefon" placeholder={"Telefon: "}   />
                        </div>


                        
                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div>                          

                </div>


                <div className="bg_center">

                    
                        <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj przekierowanie [+]</div>
                              &nbsp;&nbsp;
                        </div>


                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>
                                                <td className=" ">ID</td>
                                                <td>Nazwa</td>                                                                                                                                                                                                                                                                                                                                
                                                <td>Numer</td>                                                                                                                                    
                                                <td className="td_right">Aktywne</td>                                                                                      
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(  row.is_active == 0  )
                                                            {
                                                                rowStyle += " color_deleted " ;
                                                            }
                                                         

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td>{ix+1}</td>                                                       
                                                                <td className="gocenter">{row.id}</td>                                                       
                                                                <td className="goleft" v="edit" id={row.id} onClick={changeView} >{row.nazwa}</td>                                                              
                                                                <td className="gocenter" v="edit" id={row.id} onClick={changeView} >{row.telefon}</td>
                                                                <td className="gocenter" v="edit" id={row.id} onClick={changeView}>
                                                                     {
                                                                      row.is_active == 1 &&
                                                                      <span>Tak</span>
                                                                     }
                                                                       {
                                                                      row.is_active == 0 &&
                                                                      <span>Nie</span>
                                                                     }
                                                                </td>
                                                                <MenuTable>
                                                                    <ul>                                                         
                                                                        <li v="edit" id={row.id} onClick={changeView}>Zmień dane</li>                                                                  
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                        </table>

                </div>



    </div>

}


export default ServiceRedirect;